export const getIsLoading = state => state.isLoading;
export const getAfoDocs = state => state.docs;
